import { SaveCuentaDto } from "./cuenta";

export class Movimiento {
  constructor(
    public readonly Id: number,

    public readonly Detalle: string | null,
    public readonly TipoMovimientoId: number | null,
    public readonly TipoMovimientoNombre: string | null,
    public readonly TipoMovimientoSigno: number | null,

    public readonly CuentaImputadaId: number | null,
    public CuentaDetalleId: number | null,

    public readonly EstadoId: number | null,
    public readonly MonedaId: number | null,
    public readonly Moneda: string | null,
    public readonly AlicuotaIvaId: number | null,

    public readonly MedioPagoId: number | null,
    public readonly MedioPagoNombre: string | null,
    public readonly FechaMovimiento: Date,
    public readonly FechaVencimiento: Date,
    public readonly FechaConfirmacion: Date | null,
    public readonly FechaCancelacion: Date | null,
    public readonly UsuarioConfirmacion: string | null,
    public readonly UsuarioCancelacion: string | null,

    public readonly MontoBase: number | null,
    public readonly MontoAlicuotaIva: number | null,
    public readonly MontoPercepciones: number | null,
    public readonly Monto: number | null,
    public readonly MontoConvertido: number | null,
    public readonly Saldo: number | null,
    public readonly MonedaConversionId: number | null,
    public readonly MonedaConversion: number | null,
    public readonly SaldoConvertido: number | null,

    public readonly Cuota: number | null,
    public readonly Observacion: string | null,
    public readonly NroComprobante: string | null,

    public Adjuntos: MovimientoAdjunto[],

    public readonly GastoId: number | null,
    public readonly PedidoItemId: number | null,
    public readonly ContratoId: number | null,
    public readonly PuedeRechazar: boolean
  ) {}
}

export class SearchMovimientoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,

    public readonly FechaMovimientoDesde: Date | null,
    public readonly FechaMovimientoHasta: Date | null,
    public readonly FechaVencimientoDesde: Date | null,
    public FechaVencimientoHasta: Date | null,
    public readonly Detalle: string | null,
    public readonly NroDocumento: string | null,
    public readonly MailContacto: string | null,
    public readonly MovilContacto: string | null,
    public readonly Usuario: string | null,
    public readonly TipoMovimientoId: number | null,
    public readonly MedioPagoId: number | null,
    public readonly MonedaId: number | null,
    public readonly Estados: string | null,
    public readonly Signo: number | null,

    public readonly GastoId: number | null,
    public readonly PedidoItemId: number | null,
    public readonly ContratoId: number | null,

    public readonly ExpensaCabeceraId: number | null,
    public readonly PedidoId: number | null,
    public readonly Contrato: string | null,

    public readonly CuentaImputadaId: number | null,
    public readonly PersonaId: number | null,
    public readonly ProveedorId: number | null,
    public readonly ComunidadId: number | null,
    public readonly UnidadFuncionalId: number | null,
    public readonly ConsorcioId: number | null,

    public readonly VerSoloDeudasPendientes: boolean | null,
    public readonly VerSoloActivos: boolean | null,
    public readonly VerSoloAsociadosAUfs: boolean | null,
    public readonly MonedaConversionId: number | null
  ) {}
}

export class SearchMovimientoItemDto {
  constructor(
    public readonly Id: number,
    public readonly EstadoId: number | null,
    public readonly Estado: string | null,
    public readonly Moneda: string | null,
    public readonly TipoMovimiento: Date | null,
    public readonly FechaMovimiento: Date | null,
    public readonly Monto: number,
    public readonly Persona: string | null,
    public readonly Usuario: string | null,
    public readonly PersonaCuit: number | null,
    public readonly CuentaAlias: string | null,
    public readonly CuentaClaveBancaria: string | null,
    public readonly DetalleCuentaAlias: string | null,
    public readonly DetalleCuentaClaveBancaria: string | null,
    public readonly PuedeRechazar: boolean
  ) {}
}

export class SaveMovimientoEstadoDto {
  constructor(
    public MovimientoId: number,
    public Observacion: string
    ){}
}

export class SearchMovimientoResponse {
  constructor(
    public readonly count: number,
    public readonly result: SearchMovimientoItemDto[]
  ) {}
}

export class UploadMovimientoAttachResponseDto {
  constructor (
    public readonly Archivos: MovimientoAdjunto[]
  ) {}
}

export class MovimientoAdjunto {
  constructor (
    public readonly Id: number,
    public Descripcion: string | null,
    public readonly NombreDocumento: string | null,
    public readonly UrlDocumento: string | null,
    public readonly MovimientoId: number
  ) {}
}

export class GenerarMovimientoDeudaDto {
  constructor(
    public readonly Id: number,
    public readonly TipoMovimientoId: number | null,

    public readonly CuentaImputadaId: number | null,
    public readonly CuentaImputada: SaveCuentaDto | null,
    public readonly CuentaDetalleId: number | null,
    public readonly CuentaDetalle: SaveCuentaDto | null,

    public readonly EstadoId: number | null,
    public readonly MonedaId: number | null,
    public readonly AlicuotaIvaId: number | null,
    public readonly FechaMovimiento: Date,
    public readonly FechaVencimiento: Date | null,

    public readonly MontoBase: number,
    public readonly MontoPercepciones: number,

    public readonly CantidadCuotas: number | null,
    public readonly FechaInicioCuota: Date | null,
    public readonly DiasRepeticionCuotas: number,
    public readonly PorcentajeAjusteCuota: number,
    public readonly AplicarAjusteIncremental: boolean,

    public readonly MovimientoPagado: boolean,
    public readonly TipoMovimientoPagoId: number | null,
    public readonly MontoPagado: number | null,

    public readonly Detalle: string | null,
    public readonly NroComprobante: string | null,
    public readonly Observacion: string | null,

    public readonly EsRecurrente: boolean,
    public readonly PeriodicidadRecurrencia: number,

    public Adjuntos: MovimientoAdjunto[]
  ) {}
}

export class GenerarMovimientoPagoDto {
  constructor(
    public readonly Id: number,
    public readonly TipoMovimientoId: number | null,

    public readonly CuentaImputadaId: number | null,
    public readonly CuentaImputada: SaveCuentaDto | null,
    public readonly CuentaDetalleId: number | null,
    public readonly CuentaDetalle: SaveCuentaDto | null,

    public readonly EstadoId: number | null,
    public readonly MonedaId: number | null,
    public readonly MedioPagoId: number | null,
    public readonly AlicuotaIvaId: number | null,
    public readonly FechaMovimiento: Date,
    public readonly FechaVencimiento: Date | null,

    public readonly MontoBase: number | null,
    public readonly MontoPercepciones: number | null,

    public readonly Detalle: string | null,
    public readonly Observacion: string | null,
    public readonly NroComprobante: string | null,

    public Adjuntos: MovimientoAdjunto[],
    public readonly MovimientosDeuda: SearchMovimientoItemDto[]
  ) {}
}

export class GetSaldoRequestDto {
  constructor(
    public readonly CuentaId: number | null,
    public readonly ConsorcioId: number | null,
    public readonly ComunidadId: number | null,
    public readonly UnidadFuncionalId: number | null,
    public readonly ProveedorId: number | null,
    public readonly PersonaId: number | null,
    public readonly DescartarPendientes: boolean | null
  ) {}
}

export class GetSaldoResponseDto {
  constructor(
    public readonly HayDatos: boolean,
    public readonly Saldos: GetSaldoMonedaDto[]
  ) {}
}

export class GetSaldoMonedaDto {
  constructor(
    public readonly Moneda: string | null,
    public readonly SaldoDeudor: number,
    public readonly SaldoAFavor: number,
    public readonly SaldoVencido: number,
    public readonly SaldoTotal: number
  ) {}
}

export class SearchReporteConsolidadoCajaRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public FechaDesde: Date | null,
    public FechaHasta: Date |null,
    public FechaVencimientoDesde: Date | null,
    public FechaVencimientoHasta: Date | null,
    public MonedaId: string | null,
    public ProveedorId: number ,
    public ComunidadId: number | null,
    public ConsorcioId: number | null,
    public UnidadFuncionalId: number | null,
    public CuentaImputadaId: number | null,
    public DescartarPendientes: boolean | null,
    public VerBalancesNoCero: boolean | null,
    public CampoAgrupador: number | null,
    public MonedaConversionId: number | null
  ) { }
}

export class SearchResumenCajaRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public ComunidadNombre: string | null,
    public SuperoPuntoEquilibrio: boolean,
  ) { }
}

export class DialogCargaMovimientoRequest {
  constructor(
    public readonly Title: string | null,
    public readonly Message: string | null,
    public readonly ButtonTextAccept: string | null,
    public readonly ButtonTextCancel: string | null,
    public readonly Moneda: string | null,
    public MontoTotal: number,
    public readonly FechaMovimiento: Date
  ) {}
}

export class DialogCargaMovimientoResponse {
  constructor(
    public readonly Accepted: boolean,
    public readonly Movimientos: DialogCargaMovimientoItem[]
  ) { }
}

export class DialogCargaMovimientoItem {
  constructor(
    public readonly TipoMovimientoId: number | null,
    public readonly Importe: number | null,
    public TipoMovimiento: string | null,
    public readonly CantidadCuotas: number | null,
    public FechaInicioCuota: string | null,
    public readonly DiasRepeticionCuotas: number | null,
    public readonly PorcentajeAjusteCuota: number | null,
    public readonly AplicarAjusteIncremental: boolean | null,
    public readonly MovimientoPagado: boolean,
    public readonly TipoMovimientoPagoId: number | null,
    public readonly MontoPagado: number | null
  ) { }
}

export class SaveMovimientoRequestDto {
  constructor(
    public Id: number,

    public CuentaImputadaId: number,
    public CuentaImputada: SaveCuentaDto | null,
    public CuentaDetalleId: number,
    public CuentaDetalle: SaveCuentaDto | null,

    public EstadoId: number | null,
    public TipoMovimientoId: number | null,
    public NroComprobante: string | null,
    public Detalle: string | null,
    public Observacion: string | null,

    public MonedaId: number | null,
    public readonly AlicuotaIvaId: number | null,
    public readonly MontoBase: number | null,
    public readonly MontoPercepciones: number | null,

    public FechaMovimiento: Date | null,
    public FechaVencimiento: Date| null,

    public Adjuntos: MovimientoAdjunto[]
  ) { }
}

export class DialogDetalleMovimientosConsolidadoCajaRequestDto {
  constructor(
    public ReportFilter: SearchReporteConsolidadoCajaRequestDto,
    public SelectedRow: any
  ) {}
}

export class FinanciarDeudaDto {
  constructor(
    public readonly FechaMovimiento: Date | null,
    public readonly TipoMovimientoId: number | null,
    public readonly Detalle: string | null,
    public readonly Observacion: string | null,

    public readonly CantidadCuotas: number | null,
    public readonly FechaInicioCuota: Date | null,
    public readonly DiasRepeticionCuotas: number | null,
    public readonly PorcentajeAjusteCuota: number | null,
    public readonly AplicarAjusteIncremental: boolean,

    public readonly MovimientosDeuda: SearchMovimientoItemDto[]
  ) {}
}

export class DashboardMovimientosPorTipoMovimientoRequest {
  constructor(
    public readonly ConsorcioId: number,
    public readonly Signo: number | null
  ) {}
}

export class SearchReporteCuentasDeudorasRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,

    public readonly FechaVencimientoControl: Date | null,

    public readonly FechaMovimientoDesde: Date | null,
    public readonly FechaMovimientoHasta: Date | null,
    public readonly MonedaId: number | null,

    public readonly NroDocumento: string | null,
    public readonly MailContacto: string | null,
    public readonly MovilContacto: string | null,
    public readonly Usuario: string | null,

    public readonly ComunidadId: number | null,
    public readonly UnidadFuncionalId: number | null,
    public readonly ConsorcioId: number | null,

    public readonly VerAgrupadoPorUnidadFuncional: boolean | null,
    public readonly VerDetalleContactos: boolean | null
  ) {}
}

export class SearchReporteCuentasDeudorasItemDto {
  constructor(
    public readonly CuentaImputadaId: number,
    public readonly ConceptoId: number,
    public readonly Concepto: string | null,
    public readonly ConceptoDocumento: string | null,
    public readonly ConceptoMail: string | null,
    public readonly ConceptoMovil: string | null,

    public readonly Moneda: string | null,
    public readonly Saldo: number,
    public readonly SaldoVencido: number
  ) {}
}

export class DialogDetalleMovimientosCuentasDeudorasRequestDto {
  constructor(
    public ReportFilter: SearchMovimientoRequest,
    public FechaVencimientoControl: Date,
    public VerSoloContactos: boolean,
    public SelectedRow: any
  ) {}
}

export class SaveMovimientoFromDocumentRequestDto {
  constructor(
    public readonly Urls: string[]
  ) {}
}

export class SaveMovimientoFromDocumentResponseDto {
  constructor(
    public readonly Movimientos: Movimiento[]
  ) {}
}

export class SearchMovimientoRecurrenteRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,

    public readonly FechaMovimientoDesde: Date | null,
    public readonly FechaMovimientoHasta: Date | null,
    public readonly FechaVencimientoDesde: Date | null,
    public readonly FechaVencimientoHasta: Date | null,

    public readonly TipoMovimientoId: number | null,
    public readonly MonedaId: number | null,
    public readonly Estados: string | null,
    public readonly Signo: number,

    public readonly VerSoloRecurrentes: boolean,
    public readonly VerSoloDeudasPendientes: boolean,
    public readonly VerSoloActivos: boolean
  ) {}
}

export class EnviarDetalleDeudaRequestDto {
  constructor(
    public readonly Medio: string | null,
    public readonly PersonaId: number | null,
    public readonly SearchMovimientoFiltros: SearchMovimientoRequest
  ) {}
}

export class EnviarDetalleDeudaResponseDto {
  constructor(
    public readonly EnviadoOk: boolean,
    public readonly MensajeDeuda: string
  ) {}
}

export class GenerarMovimientoPagoMasivoRequestDto {
  constructor(
    public readonly Pagos: GenerarMovimientoPagoDto[],
    public readonly UsarCuentaDetalleDefault: boolean
  ) {}
}

export class GenerarMovimientoPagoMasivoResponseDto {
  constructor(
    public readonly MovimientoDeudaId: number,
    public readonly MovimientoPagoId: number
  ) {}
}

export class ProcessFromPagosExcelRequestDto {
  constructor(
    public NombreArchivo: string | null,
    public Archivo: any
  ) {}
}

export class ProcessFromPagosExcelResponseDto {
  constructor(
    public Pagos: ProcessFromPagosExcelItemDto[]
  ) {}
}

export class ProcessFromPagosExcelItemDto {
  constructor(
    public DeudaId: number,
    public MonedaPagoId: number,
    public Moneda: string | null,
    public MontoPagado: number
  ) {}
}
